import React from 'react';
import PanelWrapper from "../PanelWrapper";
import NoDataPanel from "../NoDataPanel";

const Index = ({ chart }) => {
    const getCounterValue = (data) => {
        if (!data || data.length === 0) return null;
        const rec = (Array.isArray(data) ? data[0] : data) || {};
        const k = Object.keys(rec)[0] || 'value';
        let v = rec[k];
        
        if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(v)) {
            const datePart = v.split('T')[0];
            const [year, month, day] = datePart.split('-');
            v = `${day}/${month}/${year}`;
        }
        
        return v;
    };
    
    return (
        <PanelWrapper 
            panel={chart}
            customNoDataRender={() => <NoDataPanel panel={{...chart, description: ""}} />}
        >
            {(panelData) => {
                const counterValue = getCounterValue(panelData);
                
                return (
                    <div className='counter-panel'>
                        <h4 className="title cds--data-table-header__title">{chart.title}</h4>
                        <h5 className="subtitle">{chart.subtitle}</h5>
                        <div className="value-container">
                            <h1 className="value">{counterValue}</h1>
                        </div>
                    </div>
                );
            }}
        </PanelWrapper>
    );
}

export default React.memo(Index)
